import { Primary } from '@cinch-labs/design-system'
import styles from './hero-cta-button.module.css'

export type HeroCtaButtonProps = {
  label: string
  url: string
}

export const HeroCtaButton: React.FC<HeroCtaButtonProps> = ({ label, url }) => (
  <Primary element="a" href={url} classNames={{ button: styles.button }}>
    {label}
  </Primary>
)
